export const GENDER_OPTIONS = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: 'BRAHMACHARI', label: 'Brahmachari' },
  { value: 'GRIHASTHA', label: 'Gṛhastha' },
  { value: 'SANNYASI', label: 'Sannyasi' },
  { value: 'VANAPRASTHA', label: 'Vānaprastha' },
  { value: 'UNMARRIED', label: 'Unmarried' },
  { value: 'OTHER', label: 'Other' },
];

export const INITIATED_WITH_OPTIONS = [
  { value: 'NO', label: 'No' },
  { value: 'HARINAM', label: 'Harinam' },
  { value: 'BRAHMIN', label: 'Brahmin' },
];

export const getInitiatedWithLabel = (value?: string | null): string => {
  if (!value || value === 'NO') return 'No';
  const option = INITIATED_WITH_OPTIONS.find((opt) => opt.value === value);
  return option?.label ?? value;
};

export const OCCUPATION_OPTIONS = [
  { value: 'STUDENT', label: 'Student' },
  { value: 'WORKING_PROFESSIONAL', label: 'Working professional' },
  { value: 'SELF_EMPLOYED', label: 'Self-employed' },
  { value: 'HOMEMAKER', label: 'Homemaker' },
  { value: 'BUSINESS', label: 'Business' },
  { value: 'RETIRED', label: 'Retired' },
  { value: 'FULL_TIME_SEVA', label: 'Full-time seva' },
  { value: 'UNEMPLOYED', label: 'Unemployed' },
  { value: 'OTHER', label: 'Other / not listed' },
];

export const EDUCATION_OPTIONS = [
  { value: 'NO_FORMAL_SCHOOLING', label: 'No formal schooling' },
  { value: 'PRIMARY', label: 'Primary (upto Class 5)' },
  { value: 'MIDDLE_SCHOOL', label: 'Middle school (Class 6-8)' },
  { value: 'SECONDARY', label: 'Secondary (10th / SSC)' },
  { value: 'HIGHER_SECONDARY', label: 'Higher secondary (12th / HSC)' },
  { value: 'DIPLOMA_POLYTECHNIC', label: 'Diploma / Polytechnic' },
  { value: 'ITI_VOCATIONAL', label: 'ITI / Vocational' },
  { value: 'BACHELORS', label: 'Undergraduate (Bachelor)' },
  { value: 'MASTERS', label: 'Postgraduate (Master)' },
  { value: 'DOCTORATE', label: 'Doctorate (PhD)' },
  { value: 'PROFESSIONAL', label: 'Professional (CA/CS/MBBS/Law)' },
  { value: 'OTHER', label: 'Other / not listed' },
];
